export default __webpack_public_path__ + "static/media/mongodb-alone.1aca075d.svg";